import { registerComponent } from '@gig/magic-common';
import CountdownComponent from './countdown.vue.js';

var Countdown = registerComponent(CountdownComponent);

export { Countdown };
